import { ReactNode } from "react";
import { Button } from "@babackapp/ui/components/button";
import { Plus } from "lucide-react";

export function PanelContent({
  children,
  title,
  description,
  onAddClick,
}: {
  children: ReactNode;
  title?: string;
  description?: string;
  onAddClick?: () => void;
}) {
  return (
    <div className="flex flex-col gap-2 p-2">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          {title && (
            <h3 className="text-sm font-medium" style={{ fontSize: "0.8rem" }}>
              {title}
            </h3>
          )}
          {description && (
            <p className="text-xs text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        {onAddClick && (
          <Button
            size="icon-xs"
            variant="ghost"
            onClick={onAddClick}
            className="h-6 w-6"
          >
            <Plus className="h-4 w-4" />
          </Button>
        )}
      </div>
      {children}
    </div>
  );
}
